import { useQuery } from '@tanstack/react-query';
import { subscriptionService, type PlanListView } from '../services/api/subscriptionService';

interface UsePlansResult {
  plans: PlanListView[] | undefined;
  isLoading: boolean;
}

export const usePlans = (): UsePlansResult => {
  const { data: plans, isFetching } = useQuery({
    queryKey: ['plans'],
    queryFn: () => subscriptionService.getPlans(),
    staleTime: 1000 * 60 * 5,
  });

  return { plans, isLoading: isFetching };
};
